import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const AddAnotherContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
`;
